// Import boostrap & index scss Style
import '../../../node_modules/bootstrap/dist/js/bootstrap';
// Import bootstrap datapicker
import '../../../node_modules/bootstrap-datepicker/dist/js/bootstrap-datepicker';
import '../../../node_modules/bootstrap-datepicker/dist/locales/bootstrap-datepicker.fr.min.js';
// Import domEvents File
import './../functions/domEvents.js';
// Import flickity
import './../libs/flickity.js';
// Import owl carousel
import '../../../node_modules/owl.carousel/dist/owl.carousel';
// Import Global Style
import '../../scss/index.scss';

// Import content load
const { showPage } = require('../functions/contentLoad.js');

jQuery(() => {

	// Insert lds-roller div
	for (let index = 0; index < 8; index++) {
		$('.lds-roller').append('<div></div>');
	}

	showPage();

});